import { useCallback } from 'react';

interface AuthUser {
  email: string;
  name: string;
}

const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN ?? 'ulikeit-admin.auth.eu-central-1.amazoncognito.com';
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID ?? '4jvfjdu4t9dk2ub2aih4g8tgvs';
const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI ?? `${window.location.origin}/login`;

export const useAuth = () => {
  const idToken = localStorage.getItem('idToken');

  const user: AuthUser | null = idToken ? parseJwt(idToken) : null;
  const isAuthenticated = !!idToken;

  const login = useCallback(() => {
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      response_type: 'code',
      scope: 'openid email profile',
      redirect_uri: REDIRECT_URI,
    });
    window.location.href = `https://${COGNITO_DOMAIN}/login?${params}`;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('idToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      logout_uri: REDIRECT_URI,
    });
    window.location.href = `https://${COGNITO_DOMAIN}/logout?${params}`;
  }, []);

  return { user, isAuthenticated, login, logout };
};

function parseJwt(token: string): AuthUser | null {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return {
      email: payload.email ?? '',
      name: payload.name ?? payload.email ?? '',
    };
  } catch {
    return null;
  }
}
